import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { GameTypeAbstract } from "../constants/gameTypes/GameTypeAbstract";
import { SitnGoVO } from "./SitnGoVO";
import { TournamentVO } from "./TournamentVO";
import { VisualVO } from "./VisualVO";

export class LobbyTablesVO extends VisualVO {
    public name: string;
    /** Abstract game type. May contain a table type (e.g. fast, Min50BB), a tournament type (e.g. shootout or freezeout) **/
    public gameType: GameTypeAbstract;
    /** Id of the table skin graphic which should be shown for the table. **/
    public skinId: number = 0;
    public counter: number = 0;
    public sBlind: number = 0;
    public players: number = 0;
    public specs: number = 0;
    public help: boolean = false;
    public pot: number = NaN;
    public actionTime: number = 0;
    public dealer: number = 0;
    public playerTurn: number = 0;
    public giftMultiplicator: number = 1;
    public fOnly: boolean = false;
    public tournamentInProgress: boolean = false;
    // 0: grün, 1: gelb ,2: rot
    public xpEarnStatus: number = 0;

    public communityCards: any[] = [];
    public seats: any[] = [];
    public bookedSeats: any[] = [];
    public tournamentVO: TournamentVO;
    public sitnGoVO: SitnGoVO;
    /** Indicates that the showdown animation is currently played.  **/
    public showdownAnimationInProgress: boolean = false;
}
classImplementsInterfaces(LobbyTablesVO, "IInventoryVO");
